import React, { useEffect, useState } from "react";
import MultiSelctCheckboxDropdown from "../../../../components/CheckboxMultiselect";
import { IconButton } from "@mui/material";
import downArrowImg from "../../../../styles/svg/downArrow.svg";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { CustomButton } from "../../../../components/Button/Button";
const MilestoneColumnHeader = () => {
  const [selectedNames, setSelectedNames] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const newSearchParams = new URLSearchParams(searchParams);
  const milestone = useSelector(
    (state) => state.listViewHeaderFilters.milestoneIds
  );

  const milestoneSearch = searchParams.get("milestone");
  const milestoneFilter = searchParams.get("columnMilestone")?.split(',')?.map(Number) || []
  useEffect(() => {
    if (!isNaN(Number(milestoneSearch))) {
      setSelectedNames([]);
    }
  }, [milestoneSearch]);

  const handleSelectionChange = (newSelection) => {
    setSelectedNames(newSelection);

    if (newSelection?.length > 0) {
      newSearchParams.set("columnMilestone", newSelection?.join(","));
    } else {
      newSearchParams.delete("columnMilestone");
    }
    setSearchParams(newSearchParams);
  };
  const handleClick = (event) => {
    setAnchorEl(event?.currentTarget);
  };

  const handleClearFilter = () => {
    setSelectedNames([]);
    newSearchParams.delete("columnMilestone");
    setSearchParams(newSearchParams);
  };

  return (
    <>
      <CustomButton className="remove-default-button-style reset-btn">
        Milestone
        <IconButton onClick={handleClick}>
          <img src={downArrowImg} alt="arrow" />
        </IconButton>
      </CustomButton>
      <MultiSelctCheckboxDropdown
        items={milestone}
        selectedItems={milestoneFilter}
        onSelectionChange={handleSelectionChange}
        isButton={true}
        anchorEl={anchorEl}
        valueKey="epic_id"
        displayKey="epic_name"
        handleClose={() => setAnchorEl(null)}
        handleClearFilter={handleClearFilter}
      />
    </>
  );
};

export default MilestoneColumnHeader;
